export default __webpack_public_path__ + "static/media/timeline-screen.16a70d1d.png";